import { SetPasswordPage } from "@/pages/SetPasswordPage";

export function SetPasswordRouteComponent() {
  return <SetPasswordPage />;
}
